<template>
  <div
    data-qa="meeting_card"
    class="d-flex flex-column gr-6"
  >
    <a
      v-if="isStaff && !isMobile"
      target="_blank"
      rel="noopener noreferrer"
      class="adminka mx-0 pa-1 d-inline-block text-body-2 align-self-start"
      :href="reverseFull({ name: 'admin:info_ethicalcommissionmeetingcase_change', args: [meetingCase.id] })"
    >
      {{ t('Править отзыв', options) }}
    </a>
    <div
      data-qa="meeting_card_case_title"
      class="text-subtitle-1 text--text"
    >
      {{ t('Отзыв №', options) }} <span data-qa="meeting_card_case_number">{{ meetingCase.case_number }}</span>
    </div>

    <CardSection
      class="mt-n2"
      :title="t('Описание ситуации', options)"
      :description="meetingCase.situation_description"
    />

    <CardSection
      :title="t('Итоги', options)"
    >
      <div
        v-if="typeof meetingCase.is_ethical_count === 'number'"
        class="d-flex align-center justify-space-between meeting-card-result"
      >
        {{ t('Отзыв этичен', options) }}
        <div class="meeting-card-result__count text-subtitle-2 success--text bg-success">
          {{ meetingCase.is_ethical_count }}
        </div>
      </div>

      <div
        v-if="typeof meetingCase.is_not_ethical_count === 'number'"
        class="d-flex align-center justify-space-between meeting-card-result"
      >
        {{ t('Отзыв неэтичен', options) }}
        <div class="meeting-card-result__count text-subtitle-2 error--text bg-error">
          {{ meetingCase.is_not_ethical_count }}
        </div>
      </div>

      <template v-if="meetingCase.voting_results">
        {{ meetingCase.voting_results }}
      </template>
    </CardSection>

    <CardSection
      :title="t('Вывод', options)"
      :description="meetingCase.conclusion"
    />
  </div>
</template>

<script lang="ts" setup>
import { useContextStore, useURLStore } from 'src/store'
import type { ContextStore, MeetingCase } from 'src/components/pages/info/ethical-commission/meetings/types'
import CardSection from 'src/components/pages/info/ethical-commission/meetings/components/MainContent/components/MeetingCard/components/CardSection.vue'
import I18NextVue from 'i18next'

const { t, language } = I18NextVue
const options = { ns: language }

defineProps<{
  meetingCase: MeetingCase
  isStaff: boolean
}>()

const { context }: ContextStore = useContextStore()
const { reverseFull } = useURLStore()

const isMobile = context.flavour === 'mobile'
</script>

<style lang="scss" scoped>
@import '~www/themes/doctors/common/variables';

.meeting-card-result {
  width: 200px;

  &__count {
    display: flex;
    justify-content: center;
    min-width: 45px;
    padding: 4px 16px;
    border-radius: $border-radius-sm;
  }
}
</style>
